export default {
  background: {
    default: require('@/assets/images/gallery/breadcrumb-bg.jpg'),
    admin: require('@/assets/images/gallery/breadcrumb-bg-admin.jpg')
  }
}
